export { SponsoredSolar } from './sponsored-solar';
